// RoleGuard.jsx
import { Navigate, useLocation, matchPath } from "react-router-dom";
import { getUserRole } from "./service/api/apiClient";
import { getRoutesForRole } from "./utils/routeConfig";

// ─── 403 page ─────────────────────────────────────────────────────────────────
const NotAuthorized = () => (
    <div style={{
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        height: "70vh", gap: 16, textAlign: "center",
    }}>
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none"
             stroke="#ef4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
        </svg>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: "#1e293b", margin: 0 }}>
            Access Denied
        </h1>
        <p style={{ fontSize: 15, color: "#64748b", margin: 0, maxWidth: 360 }}>
            You don't have permission to view this page.
        </p>
        <span style={{
            fontSize: 12, fontWeight: 600, padding: "3px 10px",
            borderRadius: 20, background: "#fef2f2",
            color: "#ef4444", border: "1px solid #fca5a5",
        }}>
            403 Forbidden
        </span>
    </div>
);

// ─── guard ────────────────────────────────────────────────────────────────────
export default function RoleGuard({ children }) {
    const location = useLocation();
    const role     = getUserRole();

    if (!role) return <Navigate to="/signin" replace />;

    const normalizedRole = role.toLowerCase().replace(/\s+/g, "_");
    const allowedRoutes  = getRoutesForRole(normalizedRole);

    const hasAccess = allowedRoutes.some((r) => {
        if (r.index) return location.pathname === "/";
        return matchPath({ path: r.path, end: true }, location.pathname) !== null;
    });

    if (hasAccess) return children;

    return <NotAuthorized />;
}